import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { SupportApiService } from '../../pages/support/support-api.service';
import { UserStore } from '../../store/user.store';
import { AlertController, ToastController } from '@ionic/angular';
import { SupportModel } from '../../pages/support/supportModel';
import { Router } from '@angular/router';
import { DiagnosticsService } from '../../core/diagnostics/diagnostics.service';
import { ReplayRecorderService } from '../../core/diagnostics/replay-recorder.service';

@Component({
  standalone: false,
  selector: 'acu-qa-widget',
  templateUrl: './acu-qa-widget.component.html',
  styleUrls: ['./acu-qa-widget.component.scss']
})
export class AcuQaWidgetComponent implements OnInit {
  public isVisible = environment.enableQaHelper;
  public isOpen = false;

  public selectedTestCase = 'GENERICO';
  public bugDescription = '';
  public sending = false;
  public includeReplay = true;

  constructor(
    private supportApi: SupportApiService,
    private userStore: UserStore,
    private alertCtrl: AlertController,
    private toastCtrl: ToastController,
    private router: Router,
    private diagnosticsService: DiagnosticsService,
    private replayRecorder: ReplayRecorderService
  ) {}

  ngOnInit() {
    console.log('AcuQaWidgetComponent initialized. Visible:', this.isVisible);
  }

  public get replayDuration(): number {
    return this.replayRecorder.getBufferDurationSeconds();
  }

  public get replayEventCount(): number {
    return this.replayRecorder.getEventCount();
  }

  async inviaSegnalazione() {
    if (this.bugDescription.length < 10) {
      const toast = await this.toastCtrl.create({
        message: 'Inserisci almeno 10 caratteri nella descrizione.',
        duration: 2000,
        color: 'warning'
      });
      await toast.present();
      return;
    }
    this.sending = true;

    // Genera diagnostica completa (Console logs, chiamate HTTP, rotte, ambiente)
    const report = this.diagnosticsService.generateReportData(this.bugDescription, this.selectedTestCase);

    const userAgent = navigator.userAgent;
    const reporterEmail = this.userStore.userLogged ? this.userStore.userLogged.email : 'early-adopter@collaudo.it';

    const messageToSupport: SupportModel = {
      data: {
        reporter: reporterEmail,
        description: report.description,
        acuplaceVersion: environment.acuplaceVersion,
        device: userAgent,
        summary: `[TECH_BUG] [${this.selectedTestCase}] `,
        requestType: 'TECH_BUG',
        replayData: this.includeReplay ? report.replayGzipBase64 : undefined,
        diagnostics: report.metadata
      }
    };

    try {
      const response = await this.supportApi.sendMessageToSupport(messageToSupport);
      const replayMsg = this.includeReplay ? `\n📹 Video Replay & Console Logs (${this.replayDuration}s) allegati.` : '';
      const alert = await this.alertCtrl.create({
        header: 'Segnalazione Inviata!',
        message: `Il bug relativo al test case ${this.selectedTestCase} è stato registrato.\nTicket: ${response.issueCreated}${replayMsg}`,
        buttons: ['OK']
      });
      await alert.present();
      
      // Reset form
      this.bugDescription = '';
      this.selectedTestCase = 'GENERICO';
      this.isOpen = false;
    } catch (e) {
      console.error('Errore nell\'invio del bug QA', e);
      const toast = await this.toastCtrl.create({
        message: 'Errore nell\'invio della segnalazione. Riprova più tardi.',
        duration: 3000,
        color: 'danger'
      });
      await toast.present();
    } finally {
      this.sending = false;
    }
  }
}
